import { render, staticRenderFns } from "./ModulesComponent.vue?vue&type=template&id=1d5db3e2&scoped=true&"
import script from "./ModulesComponent.vue?vue&type=script&lang=js&"
export * from "./ModulesComponent.vue?vue&type=script&lang=js&"
import style0 from "./ModulesComponent.vue?vue&type=style&index=0&id=1d5db3e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5db3e2",
  null
  
)

export default component.exports